export enum DocumentToolbarMode {
  Default,
  Small
}
